import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, TreeView } from "../../../Constant";
import BasicTrees from "./BasicTree";
import DisabledTree from "./DisabledTree";

const TreeViewContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={TreeView} parent={BonusUi} title={TreeView} />
      <Container fluid>
        <Row>
          <Col sm="6">
            <BasicTrees />
          </Col>
          <Col sm="6">
            <DisabledTree />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default TreeViewContainer;
